module.exports = __webpack_public_path__ + "images/AtlassianAccountOnboardingBanner/images/locks.a15aed7a1dcba6273cfa.png";